<template lang="pug">
  v-container
    .middle 
      v-skeleton-loader.mx-auto(
        max-width="50%"
        type="card")          
</template>

<script>
  export default {
    name: 'HelloWorld',

    data: () => ({
      
    }),
    
    created() {
      this.$router.push({name: 'technological-dashboard'});
    },
  }
</script>
<style scoped>
.container {
  height: 100%;
  display: table;
}
.middle {
  display: table-cell;
  vertical-align: middle;
}
</style>
